/**
 *	scripts/Nav-Toggle-Component.js
 */

window.navToggleComponent = function () {
  const body = document.querySelector('body');
  const navToggle = document.querySelector('.Nav-Toggle-Component');

  navToggle.addEventListener('click', function () {
    body.classList.toggle('nav-active');
  });
};
